import { useMemo } from 'react';
import {
  useQuoteListActionsContext,
  useQuoteListDispatchContext,
  useQuoteListStateContext,
} from './quote-list.context';
import { FormLabel, Stack, Switch } from '@mui/material';

export const ToggleObsoleteQuotesButton = () => {
  const { showObsoleteQuotes, quotes } = useQuoteListStateContext();
  const actions = useQuoteListActionsContext();
  const dispatch = useQuoteListDispatchContext();

  const obsoleteQuotes = useMemo(
    () => quotes.filter((quote) => quote.isObsolete),
    [quotes]
  );

  if (!obsoleteQuotes) {
    return null;
  }

  return (
    <Stack
      flexDirection={'row'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <FormLabel>Show obsolete quotes</FormLabel>
      <Switch
        title={'Show obsolete quotes'}
        name={'showObsoleteQuotes'}
        checked={showObsoleteQuotes}
        onChange={(event) => {
          dispatch(actions.toggleShowObsoleteQuotes(event.target.checked));
        }}
      />
    </Stack>
  );
};
